import * as React from "react";

import GenCycleButton from "./CycleButton";

interface GenToggleButtonProps {
  name: string,
  onName?: string,
  disabled?: boolean,
  value: boolean,
  onClick: (value: boolean) => void,
}

export default function GenToggleButton(
  {
    name,
    onName,
    disabled,
    value,
    onClick,
  }: GenToggleButtonProps,
) {
  return (
    <GenCycleButton
      states={[
        { "button" : {
            "name" : name,
            "highlighted" : false,
            "disabled" : false,
          },
          "value" : false,
          "nextValue" : true,
        },
        { "button" : {
            "name" : (onName || name),
            "highlighted" : true,
            "disabled" : false,
          },
          "value" : true,
          "nextValue" : false,
        },
      ]}
      disabled={disabled}
      currentValue={value}
      onClick={onClick}
    />
  );
}
